export enum AthleteRarityId {
  Beginner = 1,
  Intermediate = 2,
  Advanced = 3,
  Elite = 4,
  Legendary = 5,
}
